<mat-select [value]="selectedFormId" (valueChange)="onOptionSelected($event)" [panelWidth]="null">
  <mat-select-trigger>
    <div class="icon-container">
      {{ selectedFormName }}
      <mat-icon class="icon">expand_more</mat-icon>
    </div>
  </mat-select-trigger>
  @for (form of forms; track form.id) {
    <mat-option [value]="form.id">
      {{ form.name }}
    </mat-option>
  }
</mat-select>
